
export default [
  {
    path: 'index',
    name: 'index',
    component: () => import('./index/index.vue'),
    meta: {
      title: '首页'
    }
  },
  {
    path: 'register',
    name: 'register',
    component: () => import('./register/index.vue'),
    meta: {
      title: '注册'
    }
  },
  {
    path: 'edit',
    name: 'edit',
    component: () => import('./register/index.vue'),
    meta: {
      title: '修改信息'
    }
  },
  {
    path: 'reset-password',
    name: 'resetPassword',
    component: () => import('./reset-password/index.vue'),
    meta: {
      title: '重置密码'
    }
  },
  {
    path: 'info-fill',
    name: 'infoFill',
    component: () => import('./info-fill/index.vue'),
    meta: {
      title: '企业信息填报'
    }
  }
];
